export default __webpack_public_path__ + "locales/bg/VersionHistory.json?hash=5650a6fb55b382090644a8d30519800a";